import React, { useContext } from 'react';
import Select from 'react-select';

import { DataContext } from '../../../stores/covering-table-store';
import { COVERING_TABLE_AVAILABLE_IN_WEEK_RANGE_OPT, COVERING_TABLE_AVAILABLE_NEXT_FIVE_WEEKS_OPT, COVERING_TABLE_SHOW_ALL_OPT } from '../../../i18n/keyConstants';
import { useTranslation } from 'react-i18next';


const SelectOccupancy = ({ selectedValue }) => {
    const {
        store: { selectedOccupancy },
        dispatch,
    } = useContext(DataContext);

    const { t } = useTranslation(['coveringTable']);

    const opts = [
        { label: t(COVERING_TABLE_SHOW_ALL_OPT), value: 'all' },
        { label: t(COVERING_TABLE_AVAILABLE_NEXT_FIVE_WEEKS_OPT), value: 'availableNextFiveWeeks' },
        { label: t(COVERING_TABLE_AVAILABLE_IN_WEEK_RANGE_OPT), value: 'availableInWeekRange' },
    ];
    const selected = opts.find(o => o.value === (selectedValue || selectedOccupancy.value));
    return (
        <Select
            className='select-occupancy mr-1 mt-1'
            isClearable={false}
            isSearchable={false}
            classNamePrefix='select-container'
            value={selected}
            options={opts}
            onChange={(e) => {
                dispatch({ type: 'SELECTED_OCCUPANCY', payload: e });
            }}
        />
    );
};

export default SelectOccupancy;
